import CustomOnboarding from "./CustomOnboarding/CustomOnboarding/CustomOnboarding";

const DynamicForm = () => {
  return (
      <CustomOnboarding type="create" />
  );
};

export default DynamicForm;